import { Component } from '@angular/core';
import { BaseSectionComponent } from '../base-section.component';
import { AssetPipe } from '../../../../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-section-tools',
    templateUrl: './section-tools.component.html',
    styleUrls: ['./section-tools.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class SectionToolsComponent extends BaseSectionComponent {

}